module.exports = __webpack_public_path__ + "img/MM.a1db04f7.png";